



import {forwardRef,} from 'react'





export const forwardRadix = (c) =>
  forwardRef(c)
